var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider-thumbnails-wrapper"},[_c('div',{staticClass:"slider-thumbnails"},_vm._l((_vm.slides),function(slide,i){return _c('div',{key:i,staticClass:"slider-thumbnail",on:{"click":function($event){return _vm.goTo(slide)}}},[_c('cms-image',{attrs:{"base":{width: 60, height: 70},"src":{
					alt: _vm.product.name,
					path: slide.image?.path,
					title: `Product - ${_vm.product.name}`
				}}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }